import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { isPrototypesEnabled } from '../../config/debug';
import { useProfileRoles } from '../../hooks/useProfileRoles';

interface DevRouteProps {
  children: React.ReactNode;
  fallbackPath: string;
}

const DevRoute: React.FC<DevRouteProps> = ({ children, fallbackPath }) => {
  const location = useLocation();
  const { isLoading, isDeveloper } = useProfileRoles();

  if (!isPrototypesEnabled()) {
    return <Navigate to={fallbackPath} replace state={{ from: location }} />;
  }

  if (isLoading) {
    return (
      <div className="flex min-h-[240px] items-center justify-center text-sm text-content-muted">
        Loading developer access…
      </div>
    );
  }

  if (!isDeveloper) {
    return <Navigate to={fallbackPath} replace state={{ from: location }} />;
  }

  return <>{children}</>;
};

export default DevRoute;
